import React from "react";
import styled from "styled-components";
import NoAttributeProvided from "components/event-definitions/replay-search/NoAttributeProvided";
export const Item = styled.div`
  display: flex;
  gap: 5px;
  align-items: flex-start;
`;
export const Value = styled.div`
  display: flex;
  word-break: break-all;
`;
const Title = styled.b`
  min-width: 85px;
`;
const EventAttribute = ({
  children = null,
  title,
  inRows = false
}) => {
  if (inRows)
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("tr", { key: title }, /* @__PURE__ */ React.createElement("td", { colSpan: 2 }, /* @__PURE__ */ React.createElement(Title, null, title))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 2 }, /* @__PURE__ */ React.createElement(Value, { title }, children || /* @__PURE__ */ React.createElement(NoAttributeProvided, null)))));
  return /* @__PURE__ */ React.createElement("tr", { key: title }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Title, null, title)), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Value, { title }, children || /* @__PURE__ */ React.createElement(NoAttributeProvided, null))));
};
export default EventAttribute;
